import { Button } from "@msuite/ui/button";
import { ContentCard } from "@msuite/ui/content-card";
import { DateInput, TimeInput } from "@msuite/ui/date-input";
import { Divider } from "@msuite/ui/divider";
import { Icon, icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import type { ProtocolFormSchema } from "@msuite/utils/schemas";
import React from "react";
import { useFormContext, useWatch } from "react-hook-form";

export function ProtocolFormTime() {
	/** Context */
	const methods = useFormContext<ProtocolFormSchema>();
	const { t } = useTranslation();
	const [startTime, endTime] = useWatch({
		control: methods.control,
		name: ["startTime", "endTime"],
	});
	const hasTime = Boolean(startTime || endTime);

	/** Functions */
	function handleOnToggleTime() {
		if (hasTime) {
			methods.setValue("startTime", null);
			methods.setValue("endTime", null);
		} else {
			methods.setValue("startTime", "08:00");
			methods.setValue("endTime", "16:00");
		}
	}

	/** Render */
	return (
		<ContentCard
			variant="plain"
			icon={icon("ClockPlus")}
			title={t("dates.time")}
			contentClassName="v-stack gap-4"
		>
			<div className="h-stack items-end">
				<div>
					<DateInput
						label={null}
						control={methods.control}
						name="date"
					/>
				</div>
				<Button
					icon={<Icon name="ClockPlus" />}
					size="sm"
					onClick={handleOnToggleTime}
					variant="ghost"
				/>
			</div>
			{hasTime && (
				<React.Fragment>
					<Divider variant="content-card" />
					<div className="grid grid-cols-2 gap-4">
						<TimeInput
							control={methods.control}
							name="startTime"
							isRequired
							label={t("dates.start_time")}
						/>
						<TimeInput
							control={methods.control}
							name="endTime"
							isRequired
							label={t("dates.end_time")}
						/>
					</div>
				</React.Fragment>
			)}
		</ContentCard>
	);
}
